var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    {
      attrs: {
        title: _vm.t("ResetPasswordPage.pageTitle"),
        "sub-title": _vm.t("ResetPasswordPage.subTitle"),
      },
    },
    [
      _c(
        "sm-form",
        {
          ref: "form",
          staticClass: "reset-form",
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "fieldset",
            [
              _c("sm-input", {
                ref: "email",
                attrs: {
                  type: "email",
                  name: "email",
                  autofocus: "",
                  autocomplete: "username",
                  rules: "required|email",
                  mode: "lazy",
                  label: _vm.$t("ResetPasswordPage.emailLabel"),
                  placeholder: _vm.t("ResetPasswordPage.emailPlaceholder"),
                },
                model: {
                  value: _vm.user.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.user, "email", $$v)
                  },
                  expression: "user.email",
                },
              }),
              _vm._v(" "),
              _c(
                "sm-button",
                {
                  staticClass: "block-button",
                  attrs: {
                    "native-type": "submit",
                    type: "primary",
                    loading: _vm.loading,
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.t("ResetPasswordPage.submitButton")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "link-button",
                      attrs: { to: { name: "LoginPage" } },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("ResetPasswordPage.backToLoginLink")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.errorMessage
                ? _c("sm-help-card", {
                    attrs: { type: "warning" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.errorMessage) +
                                  "\n        "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4086182172
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }